import axios from 'axios';

import type {
  FleetRef,
  FleetStartVerificationRequest,
  FleetStartVerificationResponse,
} from '../domain/fleet-verification';

const getFleetRefs: () => Promise<FleetRef[]> = () =>
  axios.get<FleetRef[]>('/qualification/fleet-verification/fleets').then((response) => response.data);

const startVerification: (payload: FleetStartVerificationRequest) => Promise<FleetStartVerificationResponse> = (
  payload,
) =>
  axios
    .post<FleetStartVerificationResponse>('/qualification/fleet-verification/start-verification', payload)
    .then((response) => response.data);

export { getFleetRefs, startVerification };
